module.exports = {
  myOrder: {
    AllOrders: '全部订单',
    PendingPayment: '待付款',
    AwaitingShipment: '待发货',
    PendingReceipt: '待收货',
    Completed: '已完成',
    ProductNumber: '产品名称/订单号',
    ProductInformation: '产品信息',
    Quantity: '数量',
    Total: '全部',
    Status: '状态',
    Operating: '操作',
    YouHave: '您还没有下订单!',
    WillBe: '您的所有订单都将保存在这里，以便您随时访问他们的状态。',
    OrderDate: '订购日期',
    OrderNumber: '订单号',
    Seller: '商家',
    RemainingTime: '剩余时间',
    Theproducts: '以下产品缺货',
    belowAre: '以下产品缺货.',
    DoYou: '您要先将可用产品添加到购物车吗？',
    Cancel: '取消',
    Submit: '确认',
    RefundAfTe: '选择您需要退款/售后的设备',
    Items: '所有项目',
    Shipped: '已发货 ',
    SuccessfulTransaction: '交易成功',
    Cancelled: '取消订单',
    TradingClosed: '交易结束',
    PayNow: '付款 ',
    OrderDetails: '订单详细',
    ChangeAddress: '更换地址 ',
    CancelOrder: '取消订单',
    Refund: '退款',
    ConfirmReceipt: '确认收货',
    Remove: '删除订单',
    AfterSale: '退款/售后',
    BuyAgain: '再次购买',
    BeReplaced: '请选择要更换的地址',
    modified: '地址修改成功!',
    Modify: '修改收货地址',
    EachOrderCan: '每个订单只能修改一次送货地址，因为不同地区的销售税不同，所以修改地址会影响订单的最终价格。',
    TheOrder: '订单的原始收货地址',
    Name: '姓名',
    Address: '地址',
    ZipCode: '邮政编码',
    PhoneNumber: '电话号码',
    OrChoose: '或选择新的送货地址',
    AddRess: '添加新的收货地址',
    Cancellation: '您确定要取消订单吗？ 取消订单后无法恢复。',
    CancelThe: '取消订单提醒',
    successfully: '取消订单成功',
    order_After: '您确定要删除订单吗？ 删除后，数据无法恢复。',
    Reminder: '删除订单提醒'
  },
  orderAfterSale: {
    AfterSale: '退款/售后',
    ProductName: '产品名称/订单号',
    ProductInformation: '产品信息',
    Quantity: '数量',
    Total: '全部的',
    Status: '状态',
    Operating: '操作',
    YouCurrently: '您目前没有售后订单。',
    OrderDate: '订购日期',
    OrderNumber: '订单号',
    PendingSellerReview: '待审核',
    WaitingForReturn: '待退货',
    PendingSellerRefund: '待退款 ',
    UserDisagrees: '用户不同意',
    PendingUserConsent: '待用户同意',
    CompleteAfterSales: '完成售后',
    Terminated: '商家拒绝',
    UserRevoked: '用户已撤销',
    Closed: '订单关闭 ',
    RevokeApplication: '撤销申请',
    ModifyApplication: '修改申请数据',
    ReturnItems: '退换货品',
    Order_Details: '售后详情',
    AgreeToRefund: '同意退款',
    DisagreeToRefund: '不同意退款',
    Remove: '删除',
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    after_sales: '您确定撤消此售后申请吗？',
    SystemTips: '系统提示',
    removeThe: '您确定要删除订单吗？ 删除后，数据无法恢复。',
    amount: '您确定同意此退款金额吗？',
    refund_amoun: '您确定不同意此退款金额吗？'

  },
  orderDetail: {
    OrderStatus: '订单状态',
    OrderDetails: '订单详细信息 ',
    Back: '返回',
    OrderNumber: '订单号',
    OrderDate: '订购日期',
    LogisticsInformation: '物流信息',
    ShippingCarrier: '运输承运人',
    TrackingNumber: '追踪号码',
    RecipientInformation: '收件人信息',
    Name: '姓名',
    Address: '地址 ',
    ZipCode: '邮政编码',
    PhoneNumber: '电话号码',
    PaymentInformation: '支付信息',
    PaymentMethod: '付款方法 ',
    PaymentAccount: '付款帐户',
    Payment_Account: '付款帐户',
    PaymentTime: '付款时间 ',
    SellerInformation: '卖家信息 ',
    ContactSeller: '联系卖家',
    ProductInformation: '产品信息',
    Product: '产品',
    Quantity: '数量',
    Price: '价格',
    Status: '状态 ',
    Subtotal: '小计',
    Shipping: '运费',
    SalesTax: '销售税',
    TotalPayout: '总支出',
    productsThe: '以下产品缺货',
    Theproducts: '以下产品缺货.',
    wantToAdd: '您要先将可用产品添加到购物车吗？',
    Cancel: '取消 ',
    Submit: '确认',
    SendUsYour: '我们是来帮忙的！ 给我们留言，我们的代表会尽快回复您',
    YourMessage: '你的信息'
  },
  SubmitOrder: {
    PendingPayment: '待付款', // 201
    AwaitingShipment: '待发货', // 202
    Shipped: '待收货/已发货', // 203
    SuccessfulTransaction: '交易成功', // 204
    Cancelled: '已取消', // 205
    TradingClosed: '交易关闭', // 206
    SubmitOrder: '提交订单',
    PaymentSuccessful: '支付成功',
    CommodityDelivery: '商品交割',
    WaitingForReceipt: '待收货',
    Completed: '完成订单',
    successfully: '订单添加成功'
  },
  RequestARefund: {
    After_Sale: '退款/售后 ',
    Back: '返回',
    ProductInformation: '产品信息',
    Quantity: '数量 ',
    Price: '价钱',
    TotalPrice: '总价 ',
    Type: '类型',
    OnlyRefund: '只退款 ',
    RefundsAndReturns: '退款和退货',
    EnterContent: '请输入内容',
    returned: '项目可以退回。',
    Maximum: '最大',
    Reason: '原因',
    Description: '描述',
    PleaseEnterContent: '请输入内容',
    UploadImage: '上传图片',
    UploadUp: '最多上传3张图片，每张图片大小不超过5M。',
    RefundAccount: '退款账户 ',
    SubmitApplication: '提交申请表 ',
    choose: '请选择退款或退货原因！',
    description: '请填写退款说明',
    Paypal: '贝宝'
  },
  Refund: {
    RefundDetails: '退款详情 ',
    Back: '返回',
    Status: '状态',
    Reason: '原因',
    SubmitApplication: '提交申请表',
    MerchantProcessing: '商户处理',
    RefundComplete: '退款完成',
    ProductInformation: '产品信息',
    Quantity: '数量',
    Price: '价钱',
    TotalPrice: '总价',
    Shipping: '运费',
    SalesTax: '销售税',
    Type: '类型',
    Description: '表示',
    UploadImage: '上传图片',
    RefundAccount: '退款账户',
    SubmissionTime: '提交时间',
    RefundNumber: '退款单号',
    RevokeApplication: '撤销申请',
    ModifyTheApplication: '修改应用',
    Complaint: '抱怨',
    Paypal: '贝宝',
    submitted: '您的投诉已成功提交，稍后平台会有专门的客服人员为您提供帮助。',
    SystemTips: '系统提示',
    Close: '关闭',
    SellerProcessing: '卖家处理',
    UserReturns: '用户退货',
    SellerRefund: '卖家退款',
    RefundAmount: '退款金额',
    information: '退货物流信息',
    Logistics: '物流模式',
    Shipment: '物流编号',
    pleaseReturn: '卖家已同意您的退货申请，请尽快退货',
    theTimeIs: '请填写真实的物流信息。 如果超过时间，退货申请将被自动取消。',
    environmental: '温馨提示：出于环保考虑，如果有多台设备，请尽量将设备放在一个包装内发送出去。 填写退货商品物流信息时，同样填写即可。',
    address: '卖家收货地址',
    ProductLogistics: '添加退货物流信息',
    LogisticsMode: '物流模式 ',
    ShipmentNumber: '物流编号',
    Submit: '提交'
  },
  signingAddress: {
    Manage: '管理您的收货地址',
    personal: '添加并更改您经常使用的地址。',
    Delivery: '添加新的收货地址',
    YouHave: '您已经有 10 个现有的送货地址。 你不能再添加了。 您可以更改现有地址。',
    TheNumber: '地址数量已达上限',
    Youhaven: '您还没有添加地址！',
    AddNew: '现在添加一个新地址，以便您可以随时随地购物！',
    AddNewAddress: '添加新地址'
  },
  message: {
    SystemNotification: '系统通知',
    OrderNotification: '订单通知 ',
    SellerCustomerService: '卖家客服 ',
    Customer: '客户服务 ',
    SendUsyour: '我们是来帮忙的！ 给我们留言，我们的代表会尽快回复您 ',
    yourMage: '你的信息',
    Email: '电子邮件',
    IfYouPrefer: '如果您希望通过电子邮件直接与我们联系，而不是使用我们的留言板，请随时发送电子邮件至  support@yaytech.com。',
    Questions: '关于产品的问题？',
    IfYouHave: '如果您对特定产品有任何疑问，请随时使用产品页面直接与卖家沟通。 卖家通常很乐意帮助解决任何问题。'
  },
  faq: {
    title: '您好，我们在这里为您服务',
    text: '我们将引导您完成此处的大部分修复工作，或者在您需要更多帮助时将您与某人联系。',
    Buying: '购买',
    ReturnsRefunds: '退货和退款 ',
    Payment: '支付',
    LogisticsWarranty: '物流与保修'
  },
  Help: {
    title: '我们该怎样帮助你？',
    text: 'YayTech有极好的支持。 将您的信息发送给我们，我们的代表将尽快回复您 ',
    Contact: '联系我们的支持团队',
    Office: '办公时间：周一至周五，上午 8 点至下午 12 点（太平洋标准时间）我们的客户服务专家随时待命 ',
    Norton: '诺顿大街 13771 号，奇诺，CA 91710',
    Get: '获取路线',
    Email: '直接给我们发电子邮件，我们会立即回复。',
    Leave: '给我们留言 ',
    IfYou: '如果您有任何问题或想留下反馈，请填写下面的表格。 我们将尽快回答您的问题。',
    FirstName: '名字',
    ContactEmail: '联系电子邮件',
    LastName: '姓',
    PhoneNumber: '电话号码',
    messageHere: '在此处输入您的信息。',
    send: '发送'
  },
  About: {
    title: 'YayTech',
    text: 'YayTech是一个安全简单的二手设备销售市场。',
    S_story: 'YayTech的故事 ',
    second_hand: '总部位于加利福尼亚州奇诺的YayTech于2022年开启了它的数字大门。在地球震动大流行之后，对翻新设备的需求从未如此之高。在全球大流行期间，消费者变得非常清楚，他们在工作、学习和娱乐方面有多么依赖自己的设备。人们也开始意识到设备对环境的长期影响，因为芯片短缺证明，与其他所有产品一样，设备也受到资源限制。在YayTech，我们维修和翻新设备以转售，从而延长其生命周期。通过延长产品的使用寿命，YayTech确保了电子垃圾保持装置远离垃圾填埋场的有形优势。随着越来越多的人接受子女教育或在家工作，YayTech的目标是让翻新设备成为每个人都能享受的价格合理、质量高的选择。',
    Wecan: '我们可以以较低的价格提供像新设备一样工作的 iPhone、iPad、平板电脑等。 并提供全面的保修、快速的交货和一流的客户服务。 最重要的是，选择翻新对地球有好处。',
    Ourpartners: '我们的合作伙伴是电子专家，他们在出厂前测试并验证每件产品是否 100% 正常工作。 这就是您在 YayTech 购买翻新设备可享受至少 1 年保修的原因。',
    Advantages: 'YayTech的优势',
    Peoplepowered: '以人为本',
    AtHuachuang: '在YayTech，您直接与其他用户进行买卖。 去掉中间商意味着你加入了一个价格最优惠、价值最高的二手设备市场。',
    PayPalprotection: '贝宝保护',
    Buyersand: '买家和卖家使用 PayPal 直接安全地进行交易。 广泛的买卖双方保护措施确保双方安全。',
    confidence: '放心购买',
    Inorder: '为了确保我们市场的安全，我们不允许损坏的物品。 我们严格要求我们的合作伙伴在出厂前对每件产品的功能进行100%的测试和验证。',
    Helpful: '乐于助人的员工',
    Ouremployees: '我们的员工将密切关注产品质量和交易事件，并迅速回答问题。'
  },
  index: {
    SellerCenter: '卖家中心',
    RegisterToSell: '卖家注册',
    SellerPortal: '卖家门户',
    Underreview: '审核中',
    Refunding: '退款中',
    Returning: '退货中',
    Refund_successful: '退款成功',
    Refund_failed: '退款失败',
    Review_failed: '审核不通过',
    Under_review: '评审中',
    Return_completed: '拒绝退款',
    Closed: '已关闭',
    Approved: '审核通过'
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh-cn/my.js